<template>
  <div>
      <ul class="navigation-tabs">
        <li class="navigation-tabs__item" v-for="tab in tabs" :key="tab">
          <a
            class="navigation-tabs__link"
            :class="handleTabActive(tab)"
            @click="setTab(tab)"
          >
            {{ tab }}
          </a>
        </li>
      </ul>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'NavTabs',
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    selected: {
      type: String,
      required: true,
    }
  },
  methods: {
    setTab(tab) {
      this.$emit('selected', tab);
    },
    handleTabActive(tab) {
      return  this.selected === tab ? 'navigation-tabs__link--active':'';
    }
  }
}
</script>